/** Throttle interval for fragment sample and buffer-update events (2 min) */
export const FRAG_SAMPLE_INTERVAL = 120_000;
/** Interval for aggregate speed reporting (10 min) */
export const SPEED_REPORT_INTERVAL = 600_000;
/** Standard HLS buffer:low threshold; also the floor for LL-HLS latency suspension (seconds). */
export const BUFFER_LOW_THRESHOLD = 2;
/** LL-HLS telemetry threshold, below normal buffer fluctuations around the 2.7s latency target. */
export const LL_BUFFER_LOW_THRESHOLD = 1;
/** Buffer length below which a 'buffer:critical' event fires (seconds) */
export const BUFFER_CRITICAL_THRESHOLD = 0.5;
/** Consecutive non-fatal fragLoadErrors before calling onFragLoadErrorThreshold() */
export const FRAG_LOAD_ERROR_THRESHOLD = 5;
/** Consecutive fragGap errors before forcing ABR auto quality */
export const FRAG_GAP_ERROR_THRESHOLD = 5;
/** Keep trying to re-lock a user-selected manual quality before falling back to ABR auto */
export const QUALITY_REASSERT_HOLD_MS = 3000;
/** Buffer must recover above this level (seconds) before latency control resumes after a stall/low event */
export const BUFFER_RECOVERY_THRESHOLD = 2.5;
/** Start catch-up when latency >= this value (seconds) */
export const LATENCY_CATCH_UP_THRESHOLD = 4.0;
/** Start slow-down when latency <= this value (seconds) */
export const LATENCY_SLOW_DOWN_THRESHOLD = 2.0;
